export default class BaseService {

}